import React from 'react'
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl'
import { useData } from 'vike-react/useData'

import type { SanityTextContentProps } from '@slite/components'
import { Pill, SanityTextRenderer } from '@slite/components'
import { ChevronLeftIcon } from '@slite/icons'

import { Section } from '../../../components/Section'
import { SectionLastCTA } from '../../../components/SectionLastCTA'
import { SlitePage } from '../../../components/SlitePage'
import { WebsiteText } from '../../../components/WebsiteText'
import { useRoutes } from '../../../routes'
import { slugifyTitle } from '../slugify'
import type { Data } from './+data'

export default function ChangelogEntryPage() {
  const intl = useIntl()
  const routes = useRoutes()
  const { entry } = useData<Data>()

  const { title, date, coverImage, content, product } = entry

  const pageTitle = intl.formatMessage(
    {
      id: 'website.changelog.entry.helmet.title',
      defaultMessage: '{title} — Changelog',
    },
    { title }
  )

  return (
    <SlitePage
      canonicalUrl={routes.changelog.detail({ slug: slugifyTitle(title) })}
      title={pageTitle}
      ogImage={coverImage?.url ?? undefined}
      background="moon-dust-lighter"
    >
      <Section background="moon-dust-lighter">
        <div className="grid-12">
          <div className="grid-span-8-large grid-offset-2-large grid-span-12">
            <a
              href={routes.changelog.index()}
              className="shade-05 flexbox flexbox-align-center flexbox-gap-4 margin-bottom-32"
            >
              <ChevronLeftIcon size={12} />
              <FormattedMessage
                id="website.changelog.entry.breadcrumb.changelog"
                defaultMessage="Back to changelog"
              />
            </a>

            <div className="shade-30 font-size-6 margin-bottom-12">
              <FormattedDate
                value={date}
                month="short"
                day="numeric"
                year="numeric"
              />
            </div>
            <WebsiteText variant="heroTitle" className="margin-bottom-16">
              {title}
            </WebsiteText>
            {product === 'super' && (
              <a href={routes.aiSearch()} style={{ width: 'fit-content' }}>
                <Pill
                  style={{
                    height: 32,
                    lineHeight: '32px',
                    padding: '0 12px',
                  }}
                >
                  <FormattedMessage
                    id="website.changelog.entry.super"
                    defaultMessage="AI-search (super)"
                  />
                </Pill>
              </a>
            )}
            {coverImage?.url && (
              <img
                src={coverImage.url}
                alt=""
                className="width-full radius-large margin-top-32"
                style={{
                  objectFit: 'cover',
                  objectPosition: 'center top',
                }}
              />
            )}
            <div className="simple-rich-text large simple-rich-text-minimal-table flexbox flexbox-column width-full margin-top-32">
              <SanityTextRenderer
                variant="website"
                content={content as SanityTextContentProps}
              />
            </div>
          </div>
        </div>
      </Section>
      <SectionLastCTA background="moon-dust-lighter" />
    </SlitePage>
  )
}
